import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'Upload Logo',
  description:
    'Files must be smaller than 5MB. Supported file types are JPG/JPEG and PNG.',
})
